import { COMPANY } from "@/data/site";

// Build a wa.me click-to-chat link with a pre-filled message.
export const waLink = (message = "") =>
  `https://wa.me/${COMPANY.whatsapp}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const WA_MESSAGES = {
  generic:
    "Hello VOLTECH POWER SOLUTIONS, I'd like a free quote. My requirement:",
  lfp:
    "Hello VPS, I'm interested in your LFP inverter batteries. My inverter model / requirement is:",
  solar:
    "Hello VPS, I'd like bulk pricing for solar street lights. Quantity & wattage needed:",
  custom:
    "Hello VPS, I want a custom battery pack. My specs (voltage / capacity / application):",
  service:
    "Hello VPS, I'd like to book a battery service / AMC. Details:",
};
